import React, { Component} from "react";
import PropTypes from 'prop-types';
import Tools from "utils/tools";

class NoMatch extends React.Component {
  static contextTypes = {
    router: PropTypes.shape.isRequired
  };
  constructor(props) {
    super(props);
  }
  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }
  componentWillMount() {
    if (Tools.getCookie("userInfo")) {
      this.context.router.replace("/screen/home");
    } else {
      this.context.router.replace("/");
    }
  }
  render() {
    return null;
  }
}

module.exports = NoMatch;
